<script lang="ts">
  import type { Snippet } from "svelte";
  import TimeAgo from "./TimeAgo.svelte";
  import Chip from "./Chip.svelte";

  interface Props {
    type: string;
    name: string;
    description?: string;
    timestamp?: string;
    timestampLabel?: string;
    chips?: Snippet;
    footer?: Snippet;
    onClick?: () => void;
  }

  const { type, name, description, timestamp, timestampLabel, chips, footer, onClick }: Props =
    $props();
</script>

<div
  class="shadow-with-inset flex h-full min-h-[150px] w-full cursor-pointer flex-col gap-5 overflow-hidden rounded-xl bg-mono-000 p-5 shadow-border-inset transition-colors ease-in-out hover:bg-mono-200"
  onclick={onClick}
  onkeydown={(e: KeyboardEvent) => e.key === "Enter" && onClick?.()}
  role="button"
  tabindex={0}
  aria-label="entity-card"
>
  <div class="flex min-w-0 flex-1 items-start justify-between gap-2">
    <div class="flex min-w-0 flex-1 flex-col gap-3">
      <div class="flex items-center justify-between gap-3">
        {#if chips}
          <div class="flex items-center gap-2">
            {@render chips()}
            <Chip text={type?.toUpperCase()} />
          </div>
        {:else}
          <Chip text={type?.toUpperCase()} />
        {/if}
        {#if timestamp && timestampLabel}
          <span class="min-w-0 truncate text-xs text-foreground-tertiary">
            {timestampLabel}
            <TimeAgo style="short" date={timestamp} showAgo={true} />
          </span>
        {/if}
      </div>
      <div class="flex min-w-0 flex-col gap-1">
        <h3 class="truncate text-sm text-foreground-primary">
          {name}
        </h3>
        {#if description}
          <p class="truncate text-sm text-foreground-tertiary">
            {description}
          </p>
        {/if}
      </div>
    </div>
  </div>
  {#if footer}
    {@render footer()}
  {/if}
</div>
